import React, { ReactNode } from 'react';

interface ScrollViewProps {
  horizontal?: boolean;
  children?: ReactNode;
  className?: string;
  showsHorizontalScrollIndicator?: boolean;
  showsVerticalScrollIndicator?: boolean;
}

export const ScrollView: React.FC<ScrollViewProps> = ({
  horizontal = false,
  children,
  className = '',
  showsHorizontalScrollIndicator = true,
  showsVerticalScrollIndicator = true,
}) => {
  const scrollStyles: React.CSSProperties = {
    overflowX: horizontal ? 'auto' : 'hidden',
    overflowY: horizontal ? 'hidden' : 'auto',
    WebkitOverflowScrolling: 'touch',
    display: 'flex',
    flexDirection: horizontal ? 'row' : 'column',
    scrollbarWidth: 'none', // For Firefox
    msOverflowStyle: 'none', // For IE
    ...(!showsHorizontalScrollIndicator && {
      '&::-webkit-scrollbar': {
        display: 'none', // For Chrome/Safari
      },
    }),
    ...(!showsVerticalScrollIndicator && {
      '&::-webkit-scrollbar': {
        display: 'none',
      },
    }),
  };

  return (
    <div style={scrollStyles} className={className}>
      {children}
    </div>
  );
};
